
export const SOUTH_AFRICAN_PROVINCES = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'North West',
  'Northern Cape',
  'Western Cape',
] as const;

export const HURU_VERIFICATION_STATUSES = {
  YES: "Yes",
  NO: "No",
  IN_PROCESS: "In Process",
} as const;

export const EMPLOYMENT_STATUSES = {
  YES: "Yes",
  NO: "No",
} as const;
